export const elementType = {
  button: 'button',
  input: 'inputField',
  anchor: 'anchor',
  radioOption: 'radioOption',
  menu: 'menu',
};
